module.exports = __webpack_public_path__ + "img/1 px.182be7a3.svg";